import React from "react";
import { Link } from "react-router-dom";

const HelpOverview = () => {
  return (
    <div className="container">
      <h1 className="display-2">Help Section</h1>
      <p className="lead">Under Construction...</p>
      <p>
        Let us know what you'd like to see here! Rhys.Oliver@britishsugar.com
      </p>
      <ul class="list-unstyled">
        <li>Data Entry</li>
        <ul>
          <li>User Interface</li>
          <li>Colour Coding</li>
          <li>Keyboard Shortcuts</li>
        </ul>
        <li>Reporting</li>
        <ul>
          <li>Live Data</li>
          <li>Dashboards</li>
          <li>Data Grabber</li>
          <li>Reports</li>
          <li>Mobile Screens</li>
        </ul>
        <li>Parameters</li>
        <ul>
          <li>
            <Link to="/help/functions">Standard Functions</Link>
          </li>
          <li>Structures</li>
          <li>Subscriptions</li>
        </ul>
        <li>Operations</li>
        <li>Interfaces</li>
        <ul>
          <li>Factory Control System (DCS)</li>
          <li>Croplands</li>
          <li>Weighbridge (IWB)</li>
          <li>Lost Opportunity (LOP)</li>
          <li>LIMS</li>
        </ul>
      </ul>
    </div>
  );
};

export default HelpOverview;
